import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Button, ListGroup, Table, Form } from "react-bootstrap";
import { CcCircle, CheckLg, Trash } from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";
import { getAccountNo, getContractNo, getStore } from "../../../reducers/StepTwo";
import { actions as actionStep } from "../../../reducers/Step";
import { Alert } from "../../Alerts";
import FAMSA from "../../../config/constants";
import axios from "axios";
import Loading from "../../Loading";
import ModalLoan from "./modal_loan";
import { formatExpiry } from "../../generals/utils";

const StepThreeLoan = ({ handleAddCard }) => {
    const intl = useIntl();
    const distpatch = useDispatch();
    const AccountNo = useSelector(getAccountNo);
    const ContractNo = useSelector(getContractNo);
    const Store = useSelector(getStore);
    const [loading, setLoading] = useState(false);
    const [showList, setShowList] = useState(false);
    const [listCards, setListCards] = useState([]);
    const [select, setSelect] = useState(null);
    const [addCard, setAddCard] = useState(false);
    const [selectcard, setSelectCard] = useState(false);

    const CardsInfo = async () => {
        setShowList(true);
        const fullURL = FAMSA.SERVER.SERVER + `/api/CardsInfo`;
        const params = {
            "account": AccountNo,
            "store": Store,
            "contract": ContractNo
        };
        await axios.post(fullURL, params).then((response) => {
            console.log('CardInfo'+response);
            setShowList(false);
            if (response.data.StatusCode === 200) {
                setListCards(response.data.Data);
                //setAddCard(response.data.Data.length-1);
            } else {
                Alert("danger", "Error", response.data.Message);
            }
        }).catch(error => {
            //console.log(error);
            setShowList(false);
            if (error.response?.data?.StatusCode !== 500) {
                Alert("danger", "Error", error.response.data.Message);
            } else {
                Alert("danger", "Error", intl.formatMessage({id: "step.report.support"}));
            }
        });
    }

    const handleDelete = async (event, value) => {
        event.preventDefault();
        setShowList(true);
        const fullURL = FAMSA.SERVER.SERVER + `/api/DeleteCard`;
        const params = {
            "token": value.token,
            "account": value.ACCOUNTNO,
            "store": Store,
            "contract": value.CONTRACTNO
        };
        await axios.post(fullURL, params).then((response) => {
            //console.log(response);
            setShowList(false);
            if (response.data.StatusCode === 200) {
                setAddCard(false);
                setSelect(null);
                setSelectCard(false);
                CardsInfo();
                Alert("success", "", "Delete success");
            } else {
                Alert("danger", "Error", response.data.Message);
            }
        }).catch(error => {
            //console.log(error);
            setShowList(false);
            if (error.response?.data?.StatusCode !== 500) {
                Alert("danger", "Error", error.response.data.Message);
            } else {
                Alert("danger", "Error", intl.formatMessage({id: "step.report.support"}));
            }
        });
    }

    const handleSelect = (event, index, value) => {
        event.preventDefault();
        setSelect(index); 
        handleAddCard(value); 
        setAddCard(false);
        if(index === select){
            setSelectCard(!selectcard); 
        }else{
            setSelectCard(true);
        }
    }

    const handleReviewAddCart = async () => {
        await CardsInfo();
    }

    useEffect(() => {
        CardsInfo();
    }, []);

    useEffect(() => {
        if(!selectcard) {
            handleAddCard(null);
        }
    }, [selectcard]);

    useEffect(() => {
        if(addCard){
            handleReviewAddCart();
        }else{
            setAddCard(false);
            setSelectCard(false);
        }
    }, [addCard]);

    useEffect(() => {
        if(addCard){
            handleAddCard(listCards[0]);
        }
    }, [listCards]);

    return (
        <>
            {(loading) ?
                <Loading />
                :
                <>
                    <Row className='justify-content-center mx-2 my-3'>
                        <Col md={{ span: 6 }} sm={{ span: 11 }}>
                            <Row className='justify-content-center my-3'>
                                <h4 className="text-decoration-underline famsa-text-blue fw-bold"><FormattedMessage id="step.three.loan.title.pay.method" /></h4>
                            </Row>
                            <Row className='justify-content-center my-3'>
                                <h5 className="famsa-text-blue"><FormattedMessage id="step.three.loan.subtitle" /></h5>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='justify-content-center mx-1 my-3'>
                        <Col md={{ span: 9 }} sm={{ span: 11 }}>
                            {showList ?
                                <Loading />
                                :
                                <>
                                    <Table responsive="sm">
                                        <thead className="famsa-btn-blue">
                                            <tr>
                                                <th></th>
                                                <th><FormattedMessage id="step.modal.name"/></th>
                                                <th><FormattedMessage id="step.modal.numbermask"/></th>
                                                <th><FormattedMessage id="step.modal.typecard"/></th>
                                                <th><FormattedMessage id="step.modal.expiry"/></th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listCards.map((value, index) => (
                                                <>
                                                    <tr key={index} onClick={(e) => handleSelect(e, index, value)} className={(select === index && selectcard) ? "famsa-bg-gray" : ""}>
                                                        <td className="text-center">{
                                                            (addCard) ? 
                                                            (index === 0) ? <span className="text-success border border-1 border-secondary"><CheckLg /></span>: null 
                                                            : (select === index && selectcard) ? <span className="text-success border border-1 border-secondary"><CheckLg /></span> : null
                                                        }</td>
                                                        <td>{value.name}</td>
                                                        <td>{value.numberMask}</td>
                                                        <td><img src={value.cartBrandImg} alt={value.cartBrand} /></td>
                                                        <td>{formatExpiry(value.expiry)}</td>
                                                        <td>
                                                            <Button type="button" className="btn btn-danger me-1 fs-6 rounded-circle" onClick={(e) => handleDelete(e, value)}>
                                                                <Trash />
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                </>
                                            ))}
                                        </tbody>
                                    </Table>
                                </>
                            }
                        </Col>
                    </Row>
                    <Row className='justify-content-center mx-2 my-3' >
                        <Col md={{ span: 9 }} sm={{ span: 11 }} >
                            <ModalLoan openAccordion={true} CardsInfo={CardsInfo} setAddCard={(value) => {setAddCard(value)}}/>
                        </Col>
                    </Row>
                </>
            }
        </>
    );
}

export default StepThreeLoan;